import { Component, inject, OnInit } from '@angular/core'
import { Router } from "@angular/router";
import { LoggerService } from '@danangelus/ngx-app-core'
import { Message } from 'primeng/message'
import { AuthenticationService } from "../../../core/security/authentication.service";

const log = LoggerService.get('LogoutComponent')

/**
 * Automatically logs the user out
 *
 * @author Dan Bennett
 */
@Component({
    selector: 'app-logout',
    imports: [
        Message
    ],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.sass'
})
export class LogoutComponent implements OnInit {

    private authenticationService = inject(AuthenticationService)
    private router = inject(Router)

    async ngOnInit(): Promise<void> {
        log.info(`logout`, `Logging out...`)
        try {

          await this.authenticationService.logout(true)
        } catch (err) {
            log.error(`Error logging out! ${err}, User may not be logged in.`)
            await this.router.navigate(['login'])
        }
    }

}
